function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2016(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 13.79,
    height: 12.43,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7757142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 6.215,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.43,
    width: 13.79,
    height: 12.8,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4222222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 18.83,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.23,
    width: 13.79,
    height: 16.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 33.44,
    fontFamily: "Arial"
  }, "\n        Glades\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.65,
    width: 13.79,
    height: 20.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.72375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 51.95,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.25,
    width: 13.79,
    height: 21.48,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 72.99,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 83.72,
    width: 13.79,
    height: 22.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.72375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 95.065,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.41,
    width: 13.79,
    height: 22.94,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 117.88,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 129.35,
    width: 13.79,
    height: 27.17,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 142.935,
    fontFamily: "Arial"
  }, "\n        Dixie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156.52,
    width: 13.79,
    height: 27.51,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 170.275,
    fontFamily: "Arial"
  }, "\n        Gulf\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 184.03,
    width: 13.79,
    height: 28.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 198.33,
    fontFamily: "Arial"
  }, "\n        Hardee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212.64,
    width: 13.79,
    height: 28.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5322222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 227.05999999999997,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 241.47,
    width: 13.79,
    height: 31.76,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5322222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 257.35,
    fontFamily: "Arial"
  }, "\n        Gilchrist\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 273.24,
    width: 13.79,
    height: 32.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 289.28000000000003,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.32,
    width: 13.79,
    height: 32.12,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 321.38,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 337.43,
    width: 13.79,
    height: 35.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 354.95,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 372.48,
    width: 13.79,
    height: 40.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 392.885,
    fontFamily: "Arial"
  }, "\n        DeSoto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.29,
    width: 13.79,
    height: 41.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2983333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 434.255,
    fontFamily: "Arial"
  }, "\n        Hendry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 455.21,
    width: 13.79,
    height: 42.08,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.379
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 476.25,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 497.3,
    width: 13.79,
    height: 45.64,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.72375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 520.12,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 542.93,
    width: 13.79,
    height: 47.66,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 566.76,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 590.59,
    width: 13.79,
    height: 51.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.379
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 616.34,
    fontFamily: "Arial"
  }, "\n        Okeechobee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 642.09,
    width: 13.79,
    height: 57.91,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.895,
    y: 671.0450000000001,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 0,
    width: 21.19,
    height: 45.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.64875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 24.384999999999998,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.98,
    y: 0,
    width: 21.99,
    height: 45.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.974999999999994,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.97,
    y: 0,
    width: 23.85,
    height: 45.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4071428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.895,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.82,
    y: 0,
    width: 25.07,
    height: 45.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5814285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.35499999999999,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.88,
    y: 0,
    width: 32.54,
    height: 45.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.14999999999999,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.43,
    y: 0,
    width: 37.54,
    height: 45.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.256666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.20000000000002,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.97,
    y: 0,
    width: 38.13,
    height: 45.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.355
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.035,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.1,
    y: 0,
    width: 48.15,
    height: 45.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.648333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.17499999999998,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.25,
    y: 0,
    width: 51.79,
    height: 45.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.098888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.145,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Highlands\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.04,
    y: 0,
    width: 52.83,
    height: 45.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.648333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.45500000000004,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.87,
    y: 0,
    width: 65.18,
    height: 45.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.555714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 399.46000000000004,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Flagler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.05,
    y: 0,
    width: 86.91,
    height: 45.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.648333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.505,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.96,
    y: 0,
    width: 90.35,
    height: 45.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.648333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.135,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.3,
    y: 0,
    width: 90.7,
    height: 45.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8241666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.65,
    y: 22.945,
    fontFamily: "Arial"
  }, "\n        Indian_River\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 45.89,
    width: 73.45,
    height: 60.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.126666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 76.27,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 106.65,
    width: 73.45,
    height: 61.94,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.646666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 137.62,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 168.59,
    width: 73.45,
    height: 62.14,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.214
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 199.66,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 230.73,
    width: 73.45,
    height: 66.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.30375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 263.945,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 297.16,
    width: 73.45,
    height: 68.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.584444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 331.29,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 365.41,
    width: 73.45,
    height: 71.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.92875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 401.125,
    fontFamily: "Arial"
  }, "\n        Okaloosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 436.84,
    width: 73.45,
    height: 75.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.3625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 474.54499999999996,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 512.26,
    width: 73.45,
    height: 91.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.492857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 557.79,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.79,
    y: 603.32,
    width: 73.45,
    height: 96.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.161111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.515,
    y: 651.6600000000001,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.24,
    y: 45.89,
    width: 77.99,
    height: 93.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.141428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.23499999999999,
    y: 92.64500000000001,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.22,
    y: 45.89,
    width: 78.35,
    height: 93.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.705555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.39499999999998,
    y: 92.64500000000001,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.57,
    y: 45.89,
    width: 84.62,
    height: 93.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.88,
    y: 92.64500000000001,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 45.89,
    width: 84.81,
    height: 93.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.60125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.595,
    y: 92.64500000000001,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 45.89,
    width: 94.82,
    height: 93.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.3775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.40999999999997,
    y: 92.64500000000001,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.82,
    y: 45.89,
    width: 95,
    height: 93.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.358571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.3199999999999,
    y: 92.64500000000001,
    fontFamily: "Arial"
  }, "\n        Collier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.82,
    y: 45.89,
    width: 97.18,
    height: 93.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.585
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.4100000000001,
    y: 92.64500000000001,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.24,
    y: 139.4,
    width: 105.31,
    height: 88.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.62857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.89499999999998,
    y: 183.60000000000002,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.24,
    y: 227.8,
    width: 105.31,
    height: 111.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.16375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.89499999999998,
    y: 283.345,
    fontFamily: "Arial"
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.24,
    y: 338.89,
    width: 105.31,
    height: 113.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.16375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.89499999999998,
    y: 395.465,
    fontFamily: "Arial"
  }, "\n        Sarasota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.24,
    y: 452.03,
    width: 105.31,
    height: 119.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.062
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.89499999999998,
    y: 511.585,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.24,
    y: 571.14,
    width: 105.31,
    height: 128.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.044285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.89499999999998,
    y: 635.5699999999999,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.54,
    y: 139.4,
    width: 106.23,
    height: 139.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.655,
    y: 209.01,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.77,
    y: 139.4,
    width: 117.6,
    height: 139.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.57,
    y: 209.01,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.37,
    y: 139.4,
    width: 121.96,
    height: 139.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 40.65333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.35,
    y: 209.01,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.33,
    y: 139.4,
    width: 161.67,
    height: 139.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.844
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.1650000000001,
    y: 209.01,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.54,
    y: 278.62,
    width: 202,
    height: 126.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.53999999999996,
    y: 342.02,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.54,
    y: 405.42,
    width: 202,
    height: 140.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.444999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.53999999999996,
    y: 475.755,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.54,
    y: 546.09,
    width: 202,
    height: 153.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.825833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.53999999999996,
    y: 623.0450000000001,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.54,
    y: 278.62,
    width: 135.39,
    height: 254.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.538999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.235,
    y: 405.85,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.93,
    y: 278.62,
    width: 170.07,
    height: 254.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.295714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.9649999999999,
    y: 405.85,
    fontFamily: "Arial"
  }, "\n        Broward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.54,
    y: 533.08,
    width: 305.46,
    height: 166.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.27,
    y: 616.5400000000001,
    fontFamily: "Arial"
  }, "\n        Miami-Dade\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2016);
export default __webpack_public_path__ + "static/media/2016.447f06636ab1f9c7193a0329f076d3cb.svg";
export { ForwardRef as ReactComponent };